import React, { useCallback, useEffect, useRef, useState } from 'react';
import Header from 'components/Header';
import backIcon from 'assets/img/left-arrow.svg';
import kanbanIcon from 'assets/img/khanban-icon.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import FOLDER_ICON from 'assets/img/folder.svg';
import notificationIcon from 'assets/img/notification.svg';
import bellIcon2 from 'assets/img/bell-01.svg';
import bellIcon from 'assets/img/bell.svg';
import featherMenu from 'assets/img/feather-menu.svg';
import rightArrowdown from 'assets/img/right-arrow-down.svg';
import akarFile from '../../../assets/img/akar-file.svg';
import CardWithIcon from 'shared/UI/CardWithIcon';
import dashboardIcon from 'assets/img/dashboard-icon.svg';
import dashboardIcon2 from 'assets/img/dashboardicon.svg';
import calenderIcon from 'assets/img/calendar-date.svg';
import BoardIcon2 from '../../../assets/img/board-icon2.svg';
import searchIcon from 'assets/img/search.svg';
import APIServices from 'services/APIServices';
import appToast, { TOAST_TYPE } from 'utils/AppToast';
import {
  fetchAndFormatUserDetails,
  formFields,
  getCookies,
  getformattedPhoneNumber,
  hasPermission,
  orgNameLimit,
  selectLoader
} from 'utils/Helpers';
import { useAuth } from 'contexts/AuthContext';
import './ProjectBoards.css';
import KbAddProjectModal from '../kanban/modals/KbAddProjectModal';
import SaveModalKanban from 'components/SaveModalKanban';
import { createProjectBoard } from '../kanban/utils/fetchData';
import boardToast from '../kanban/utils/boardToast';
import Axios from '../kanban/utils/Axios';
import SidebarModal from 'components/SidebarModal';
import Notifications from 'components/Notifications';
import UpdateProfileModal from '../homeModals/UpdateProfileModal';
import ProfileModalContent from '../homeModals/ProfileModalContent';
import { ProjectListStrings } from '../strings/ProjectStrings';
import Select, { components } from 'react-select';
import { fetchEnumOptions } from 'utils/fetchData';
import MasterCalender from '../kanban/MasterCalender/MasterCalender';
import Tippy from '@tippyjs/react';

const ProjectBoards = () => {
  const isFetchingRef = useRef(false);
  const { user, userRole, subInfo, logout, fetchUserInfo, isUser1, socket, userShortName } = useAuth();
  const location = useLocation();
  const isCalenderView = location.state?.isCalenderView;
  const scrollRef = useRef(null);
  const [projects, setProjects] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [modals, setModals] = useState({
    addProject: false,
    profileModal: false,
    updateProfile: false,
    updateProject: false,
    notifications: false
  });
  const [isUnread, setUnread] = useState(false);
  const [projectTitle, setProjectTitle] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);
  const [profileUrl, setProfileUrl] = useState('');
  const [formValues, setFormValues] = useState(formFields);
  const [loading, setLoading] = useState(false);
  const [currentStatus, setCurrentStatus] = useState('all');
  const [statusOptions, setStatusOptions] = useState([]);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1); // Default to page 1
  const [totalBoards, setTotalBoards] = useState(0);
  const [totalsByType, setTotalsByType] = useState({});
  const [pageView, setPageView] = useState('projects');
  const [isVerified, setVerified] = useState({
    isEmailVerified: true,
    isPhoneNumberVerified: true
  });
  const [sortOptions, setSortOptions] = useState([]);
  const [selectedSortBy, setSelectedSortBy] = useState('');
  const [initialLoading, setInitialLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [isArchived, setIsArchived] = useState(false);
  const navigate = useNavigate();

  const toggleModal = (modalType, isOpen) => {
    setModals((prevState) => ({
      ...prevState,
      [modalType]: isOpen
    }));
  };

  const getUserDetails = async () => {
    const result = await fetchAndFormatUserDetails(logout, fetchUserInfo, user);
    if (result) {
      setFormValues((prev) => ({ ...prev, ...result.formValues }));
      setVerified(result.verified);
    }
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  useEffect(() => {
    if (isCalenderView) {
      setPageView('calender');
      // ✅ Remove state from params after reading it
    }
    setTimeout(() => {
      navigate(location.pathname, { replace: true, state: {} });
    }, 100);
  }, [isCalenderView]);

  const latestRequestRef = useRef(0);

  const fetchProjects = async (
    search = '',
    currentStatus = '',
    page = 1,
    showLoader = true,
    archived = false,
    sendType = false
  ) => {
    const requestId = ++latestRequestRef.current;
    try {
      // if (page === 1) {
      //   setProjects([]); // 👈 clear out old data first
      // }
      if (page === 1) {
        setInitialLoading(true);
      } else {
        setLoadingMore(true);
      }
      // setPageLoading(showLoader);
      const params = {
        search,
        page,
        limit: 32,
        sortby: selectedSortBy
      };

      // ✅ Only add type if NOT archived
      if (currentStatus !== 'archived' && !archived) {
        params.type = currentStatus;
        params.archived = false;
      } else {
        if (sendType) {
          params.type = currentStatus;
        }
        params.archived = true;
      }

      const response = await Axios.get('/project-board', { params });
      // const response = await Axios.get(
      //   `/project-board?search=${search}&type=${currentStatus}&archived=${currentStatus === 'archived' ? true : isArchived}&page=${page}&limit=30`
      // );

      if (requestId !== latestRequestRef.current) return; // a newer request superseded this one
      if (response.projectBoards) {
        const formatData = response.projectBoards.map((value) => ({
          workspaceName: value.workspaceName,
          id: value.isProjectRelatedBoard ? value.projectId : value.parentBoardId ? value.parentBoardId : value._id,
          isProjectRelatedBoard: value.isProjectRelatedBoard,
          childBoardCount: value.childBoardCount,
          boardId: value?._id,
          isPinned: value?.isPinned
        }));

        setProjects((prev) => (page === 1 ? formatData : [...prev, ...formatData]));
        setTotalBoards(response?.totalBoards || 0);

        // update "hasMore"
        setHasMore(formatData.length === 32);
        setCurrentPage(page);
        setTotalsByType(response?.totalsByType || {});
      } else if (response?.data?.message) {
        appToast(response?.data?.message, TOAST_TYPE.ERROR);
      }
    } catch (error) {
      console.error('Error fetching projects:', error);
      if (requestId === latestRequestRef.current) appToast('Failed to load workspaces. Please try again.', TOAST_TYPE.ERROR);
    } finally {
      if (requestId === latestRequestRef.current) {
        setPageLoading(false);
        setInitialLoading(false);
        setLoadingMore(false);
        isFetchingRef.current = false;
      }
    }
  };

  const fetchStatusOptions = async () => {
    try {
      const response = await fetchEnumOptions('project_board_type');
      if (response.length > 0) {
        const optionsData = response;
        const formattedStatus = optionsData.map((option) => ({
          id: option._id,
          value: option.value,
          label: option.name
        }));
        console.log(formattedStatus, 'formattedStatus');

        setStatusOptions(formattedStatus);
        let onTimeStatus = formattedStatus.find((x) => x.value == 'ontime');
      }
    } catch (error) {
      console.error('Error fetching status options:', error);
    } finally {
      setLoading(false);
    }
  };
  const fetchSortOptions = async () => {
    try {
      const response = await fetchEnumOptions('projectboardsorting');

      if (response.length > 0) {
        const formattedOptions = response.map((option) => ({
          id: option._id,
          value: option.value,
          label: option.name
        }));

        setSortOptions(formattedOptions);
        let defaultOption = formattedOptions.find((option) => option.value === 'ALPHABETICAL');
        setSelectedSortBy(defaultOption?.id || '');
      }
    } catch (error) {
      console.error('Error fetching sort options:', error);
    }
  };
  useEffect(() => {
    if (user) {
      fetchStatusOptions();
      fetchSortOptions();
    }
  }, [user]);

  useEffect(() => {
    const element = scrollRef.current;
    if (!element) return;

    const onScroll = () => {
      const isAtBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 50;
      if (isAtBottom && !isFetchingRef.current && hasMore) {
        isFetchingRef.current = true;
        fetchProjects(search, currentStatus, currentPage + 1);
      }
    };

    element.addEventListener('scroll', onScroll);
    return () => element.removeEventListener('scroll', onScroll);
  }, [currentPage, pageLoading, hasMore, search, currentStatus]);

  useEffect(() => {
    if (!user?._id  || !selectedSortBy) return;
    const handler = setTimeout(() => {
      // Reset to page 1 whenever filters change
      setIsArchived(false);
      fetchProjects(search, currentStatus, 1);
    }, 300);
    return () => clearTimeout(handler);
  }, [search, currentStatus, user?._id, selectedSortBy]);

  useEffect(() => {
    // Listen for 'projectActivityUpdate' event
    if (socket) {
      const handle_Notification = (Notification) => {
        // scrollToBottom();
        setUnread(true);
        // console.log('Notification', Notification);
      };
      socket?.on('Notification', handle_Notification);
      return () => {
        socket?.off('Notification', handle_Notification);
      };
    }
  }, [socket]);

  const headerContent = () => {
    return (
      <>
        <div className="btn-group-head project-board-head">
          {pageView === 'projects' && (
            <>
              <Tippy content={'Total Workspaces'} placement="top" arrow={true}>
                <button className="btn-black">
                  <span>
                    {totalBoards < 10 && 0}
                    {totalBoards}
                  </span>
                  Workspace{totalBoards > 1 && 's'}
                </button>
              </Tippy>

              <div className="btn-black project-btn-list">
                <Tippy content={'Workspace'} placement="top" arrow={true}>
                  <span
                    className="light-blue-bg"
                    onClick={() => {
                      if (currentStatus === 'archived') {
                        setIsArchived(true);
                        fetchProjects(search, 'board', 1, false, true, true);
                      } else {
                        setIsArchived(false);
                        setCurrentStatus('board');
                      }
                    }}>
                    {totalsByType?.board < 10 && 0}
                    {totalsByType?.board || 0}
                  </span>
                </Tippy>

                <Tippy content={'Project'} placement="top" arrow={true}>
                  <span
                    className="light-green-bg"
                    onClick={() => {
                      if (currentStatus === 'archived') {
                        setIsArchived(true);
                        fetchProjects(search, 'project', 1, false, true, true);
                      } else {
                        setIsArchived(false);
                        setCurrentStatus('project');
                      }
                    }}>
                    {totalsByType?.project < 10 && 0}
                    {totalsByType?.project || 0}
                  </span>
                </Tippy>
              </div>
            </>
          )}
        </div>
        <div className="head-right">
          <img
            src={dashboardIcon2}
            alt="menu"
            className="feather-img feather-img2 menuicon cursor_pointer hw-27"
            onClick={() => {
              navigate('/');
            }}
          />
          <Tippy
            // content={`Color: ${namer(x.color).ntc[0].name}, title: ${x?.name}`}
            content={'Happy Clients'}
            placement="top"
            arrow={true}>
            <img
              src={dashboardIcon2}
              alt="menu"
              className="feather-img dark-feather-img2 menuicon cursor_pointer hw-27"
              onClick={() => {
                navigate('/');
              }}
            />
          </Tippy>
          {/* {pageView === 'projects' ? ( */}
          <Tippy content={'Happy Projects'} placement="top" arrow={true}>
            <img
              src={kanbanIcon}
              alt="menu"
              className={`feather-img menuicon cursor_pointer ${pageView === 'projects' ? 'active_img' : ''}`}
              onClick={() => {
                setPageView('projects');
              }}
            />
          </Tippy>
          <Tippy content={'My Calendar'} placement="top" arrow={true}>
            <img
              src={calenderIcon}
              alt="menu"
              className={`feather-img menuicon cursor_pointer ${pageView === 'projects' ? '' : 'active_img'}`}
              onClick={() => {
                // navigate('/');
                setPageView('calender');
              }}
            />
          </Tippy>
          {/* ) : ( */}

          {/* )} */}

          {/* <img src={backIcon} alt="back-icon" style={{ cursor: 'pointer' }} onClick={handleBackClick} /> */}
          {((subInfo?.isActive && isUser1) || !isUser1) && (
            <div className="notify-drp cursor_pointer" onClick={() => {
                setUnread(false);
                toggleModal('notifications', true);
              }}>
              <Tippy
                // content={`Color: ${namer(x.color).ntc[0].name}, title: ${x?.name}`}
                content={'Notifications'}
                placement="top"
                arrow={true}>
                {isUnread ? (
                  <img src={bellIcon2} alt="comp1" className="notification-img" />
                ) : (
                  <img src={notificationIcon} alt="comp1" className="notification-img" />
                )}
              </Tippy>
            </div>
          )}
          <a
            className="menuicon-user"
            onClick={() => {
              toggleModal('profileModal', true);
            }}>
            {userShortName}
            <img
              src={rightArrowdown}
              alt="menu"
              className="menuicon2"
              // Sidebar toggle handler
            />
            {/* <img
              src={featherMenu}
              alt="menu"
              className="feather-img menuicon"
              onClick={() => {
                toggleModal('profileModal', true);
              }} // Sidebar toggle handler
            /> */}
          </a>
        </div>
      </>
    );
  };

  const handleProjectClick = (value) => {
    navigate(`/project-board/${value.id}`, {
      state: {
        isProjectRelatedBoard: value.isProjectRelatedBoard,
        showBack: false,
        isArchivedParent: currentStatus == 'archived' || false
      }
    });
  };

  const handleSubmit = async (title) => {
    try {
      setIsSaving(true);
      const response = await createProjectBoard(title, null, false);
      if (response) {
        boardToast('Board created Successfully', TOAST_TYPE.SUCCESS);
        toggleModal('addProject', false);
        console.log(response);
        setProjects((prevState) => [
          ...prevState,
          {
            workspaceName: title,
            id: response.isProjectRelatedBoard ? response.projectId : response._id,
            isProjectRelatedBoard: response.isProjectRelatedBoard,
            boardId: response?._id
          }
        ]);
        handleProjectClick({
          workspaceName: title,
          id: response.isProjectRelatedBoard ? response.projectId : response._id,
          isProjectRelatedBoard: response.isProjectRelatedBoard
        });
      }
    } catch (error) {
      console.error('Error creating project board:', error);
      boardToast(error.response.data.message || error.message || 'Failed to create project board.', TOAST_TYPE.ERROR);
    } finally {
      setIsSaving(false);
      setProjectTitle('');
      setPageLoading(false);
    }
  };

  const CustomMenuList = ({ children, ...props }) => {
    return (
      <components.MenuList {...props}>
        <div className="select-menu-title">{props.selectProps.menuTitle}</div>
        {children}
      </components.MenuList>
    );
  };

  const refreshProjectsAfterCardAction = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }

    return fetchProjects(search, currentStatus, 1, false);
  };

  const getEmptyStateMessage = () => {
    const hasSearch = search.trim().length > 0;

    if (currentStatus === 'board') {
      return hasSearch
        ? 'No workspaces match your search.'
        : 'You have no workspaces at the moment.';
    }

    if (currentStatus === 'project') {
      return hasSearch
        ? 'No projects match your search.'
        : 'You have no projects at the moment.';
    }

    if (currentStatus === 'archived') {
      return hasSearch
        ? 'No archived workspaces or projects match your search.'
        : 'You have no archived workspaces or projects at the moment.';
    }

    return hasSearch
      ? 'No workspaces or projects match your search.'
      : 'You have no workspaces or projects at the moment.';
  };

  return (
    <div className="wrapper kanban-board kanban-wrapper">
      <Header isBoard={true} content={headerContent()} />
      {pageView == 'projects' ? (
        <section className="dashboard-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="card-top-sec">
                  <div className="top-field-cover w-100">
                    <div className="form-group search-box">
                      <input
                        maxLength={orgNameLimit}
                        type="search"
                        id="search-box-tour"
                        className="form-control search-box-control "
                        placeholder={ProjectListStrings.searchPlaceholder}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => {
                          setSearch(e.target.value);
                        }}
                      />
                      <img src={searchIcon} className="search-icon" />
                    </div>

                    <div className="form-group select-status form-group-select-icon">
                      <Select
                        className={`form-control select2 select-status`}
                        placeholder="Type"
                        menuTitle="Type"
                        options={statusOptions || []}
                        value={statusOptions.find((option) => option.value === currentStatus) || null}
                        onChange={(option) => setCurrentStatus(option?.value)}
                        onClick={(e) => e.stopPropagation()}
                        components={{
                          MenuList: CustomMenuList
                        }}
                      />
                    </div>
                    <div className="form-group select-status form-group-select-icon select-icon-dot">
                      <Select
                        className="form-control select2 select-status"
                        placeholder="Sort By"
                        menuTitle="Sort By"
                        options={sortOptions || []}
                        value={sortOptions.find((option) => option.id === selectedSortBy) || null}
                        onChange={(option) => setSelectedSortBy(option?.id)}
                        onClick={(e) => e.stopPropagation()}
                        components={{
                          MenuList: CustomMenuList
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container projects-boards-container" ref={scrollRef}>
            {/* {pageLoading && <div className="nodata-loader">{selectLoader(70)}</div>} */}
            {/* <div className="d-flex gap-3 flex-wrap"> */}

            {initialLoading ? (
              <div className="nodata-loader">{selectLoader(70)}</div>
            ) : projects.length > 0 ? (
              <>
                <div className="row project-boards-card">
                  {projects.map((value) => (
                    <div key={value.boardId} className="col-lg-3 col-md-6 mb-20">
                      <CardWithIcon
                        projectId={value.boardId}
                        img={FOLDER_ICON}
                        title={value.workspaceName}
                        onClick={() => handleProjectClick(value)}
                        isProjectRelatedBoard={value.isProjectRelatedBoard}
                        childBoardCount={value.childBoardCount}
                        fetchProjects={refreshProjectsAfterCardAction}
                        openDropdownId={openDropdownId}
                        setOpenDropdownId={setOpenDropdownId}
                        isArchiveActive={currentStatus == 'archived'}
                        fetchProjectsforArchive={() => {
                          setCurrentStatus('archived');
                          // fetchProjects();
                        }}
                        initialPinned={value.isPinned}
                        setProjects={setProjects}
                      />
                    </div>
                  ))}
                </div>
                {loadingMore && <div className="bottom-loader">{selectLoader(40)}</div>}

                {/* ✅ NO MORE DATA */}
                {/* {!hasMore && currentPage > 1 && (
                  <div className="end-text">No more data</div>
                )} */}
              </>
            ) : (
              <section className="blank-sec dashboard-sec w-100">
                <div className="container">
                  <div className="row align-items-start">
                    <div className="col-lg-12">
                      <div className="blankList-box-cover">
                        <div className="blankList-box">
                          <img className="akarFile" src={akarFile} />
                          <h2>{getEmptyStateMessage()}</h2>
                          {/* {hasPermission(userRole, 'update_projects') && (
                            <p>{ProjectListStrings.noProjectsDescription}</p>
                          )} */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}
            {/* </div> */}

            <button
              icon={'fas fa-plus'}
              styles={{ backgroundColor: 'blue', color: 'white' }}
              onClick={() => {
                toggleModal('addProject', true);
              }}
              className={`add-btn`}>
              <i className="fas fa-plus"></i>
            </button>
          </div>
        </section>
      ) : (
        <MasterCalender />
      )}
      <SidebarModal show={modals.profileModal} onHide={() => toggleModal('profileModal', false)}>
        <ProfileModalContent
          profileUrl={profileUrl}
          formValues={formValues}
          isVerified={isVerified}
          toggleModal={toggleModal}
          userRole={userRole}
          hasPermission={hasPermission}
          logout={logout}
          subInfo={subInfo}
          templateBackUrl={`/project-boards`}
        />
      </SidebarModal>
      <SidebarModal
        extraClass={'edit-profile-modal'}
        show={modals.updateProfile}
        onHide={() => toggleModal('updateProfile', false)}
        headerTitle={ProjectListStrings.editProfileHeader}>
        <UpdateProfileModal
          show={modals.updateProfile}
          profileUrl={profileUrl}
          formValues={formValues}
          setError={setError}
          isVerified={isVerified}
          toggleModal={toggleModal}
          setFormValues={setFormValues}
          selectLoader={selectLoader}
          setProfileUrl={setProfileUrl}
        />
      </SidebarModal>
      {/* Modal Component */}
      <SidebarModal
        extraClass={'edit-profile-modal notification-modal'}
        show={modals.notifications}
        onHide={() => toggleModal('notifications', false)}
        headerTitle={'Happy Ending Project'}>
        <Notifications closeModal={() => toggleModal('notifications', false)} />
      </SidebarModal>
      <SaveModalKanban
        show={modals.addProject}
        onHide={() => {
          toggleModal('addProject', false);
          setProjectTitle('');
        }}
        isCreateBoard={true}
        onSave={handleSubmit}
        title={projectTitle}
        onTitleChange={setProjectTitle}
        isLoading={isSaving}
        isWorkspace={true}
      />
    </div>
  );
};

export default ProjectBoards;
